import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { setIsInstructions } from '../../../../redux/Slices/CloudPrepSlice';
import { setIsStartTest } from '../../../../redux/Slices/QuestionsSlice';
import { setCurrentTime } from '../../../../redux/Slices/StartTestSlice/startFulTest';
import { useAppDispatch, useAppSelector } from '../../../../redux/store/hooks';
import { useStartCloudPrepTestMutation } from '../../../../services/cloudPrepApi';
import Button from '../../../Common/Button';

import { modules } from './data';

const CloudPrepInstructions = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { openCard, selectedTestData } = useAppSelector(
    state => state.root.cloudPrep
  );

  const currentModule = modules?.find(item =>
    selectedTestData?.testType?.includes(item.id)
  );
  const [startCloudPrepTest] = useStartCloudPrepTestMutation();

  const handleStartTest = async () => {
    try {
      if (!selectedTestData?.testSetId) {
        return;
      }

      const testType =
        selectedTestData?.testType ||
        selectedTestData?.cloudPrepTestDTO?.testType;

      if (!testType) {
        return;
      }

      await startCloudPrepTest({
        userTestId: selectedTestData.userTestId,
        testSetId: selectedTestData.testSetId,
        testType: selectedTestData.testType
      }).unwrap();

      // 👇 SET TIMER BASED ON EXAM
      // 👇 SET TIMER BASED ON EXAM
      if (testType === 'AZURE_DP_900' || testType === 'AZURE_AI_900') {
        dispatch(setCurrentTime(2700)); // 45 minutes
      } else if (
        testType === 'AWS_CLOUD_PRACTITIONER' ||
        testType === 'AWS_AI_PRACTITIONER' ||
        testType === 'GOOGLE_CLOUD_DIGITAL_LEADER' ||
        testType === 'GOOGLE_AI_LEADER'
      ) {
        dispatch(setCurrentTime(5400)); // 90 minutes
      }
      dispatch(setIsStartTest(true));
      dispatch(setIsInstructions(false));

      navigate(`/cloud-prep/tests/${selectedTestData.userTestId}`);
    } catch (error) {
      // intentionally left empty
    }
  };
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (window.location.pathname.includes('/cloud-prep/instructions')) {
        event.preventDefault();
        event.returnValue = '';

        sessionStorage.setItem('redirectAfterReload', 'true');
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
  return (
    <div className='min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 px-4 pb-8 pt-2'>
      <div className='mx-auto max-w-7xl'>
        <div className='mb-3 text-center'>
          <h3 className='text-xl font-bold text-slate-800'>Instructions</h3>
        </div>

        <div className='rounded-lg border border-gray-200 bg-white p-8'>
          <div className='mb-6 border-b border-gray-200 pb-6'>
            <h2 className='mb-2 text-2xl font-semibold text-gray-900'>
              {currentModule?.title}
            </h2>

            <div className='text-sm text-gray-600'>
              {currentModule?.code} • {currentModule?.duration} •{' '}
              {currentModule?.questions} Questions
            </div>
          </div>

          <div className='mb-8'>
            <h3 className='mb-3 text-lg font-medium text-gray-900'>
              Description
            </h3>

            <p className='leading-relaxed text-gray-700'>
              {currentModule?.description}
            </p>
          </div>

          <div>
            <h3 className='mb-4 text-lg font-medium text-gray-900'>
              Guidelines
            </h3>

            <ul className='space-y-3'>
              {currentModule?.guidelines?.map((guideline, index) => (
                <li key={guideline} className='flex items-start text-gray-700'>
                  <span className='mr-3 inline-block h-6 w-6 text-center text-sm font-medium text-gray-500'>
                    {index + 1}.
                  </span>
                  <span>{guideline}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className='mt-8 border-t border-gray-200 pt-6'>
            <p className='text-sm text-gray-600'>
              <span className='font-medium'>Note:</span> Ensure stable internet.
            </p>
          </div>

          <div className='bg-slate-50 py-6'>
            <Button
              handleClickBtn={handleStartTest}
              variant='contained'
              label='Start Test'
              classes='!ml-0'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloudPrepInstructions;
